// extracted by mini-css-extract-plugin
module.exports = {"Container":"Footer_Container__2h2mQ","Floating":"Footer_Floating__1sDym","Logo":"Footer_Logo__13rye","Links":"Footer_Links__2AbBk","Social":"Footer_Social__17zNL"};